import { motion } from "framer-motion";
import { Mail, MapPin } from "lucide-react";

const MidPageCTA = () => {
  return (
    <section className="py-24 px-6 bg-secondary">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-heading font-medium text-foreground mb-4">
              Ready to Begin?
            </h2>
            <div className="w-16 h-px bg-accent mb-8" />
            <p className="font-body text-muted-foreground font-light leading-relaxed mb-10">
              Taking the first step can feel like the hardest part — but you don't have to have it all figured out. Whether you're ready to book or just want to ask a question, I'm here. A free 15-minute consultation is a simple, no-pressure way to see if we're a good fit.
            </p>

            <div className="flex flex-col gap-4 text-muted-foreground font-body text-sm">
              <div className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-accent" strokeWidth={1.5} />
                <span>Dallas, TX</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-accent" strokeWidth={1.5} />
                <span>ashley@stillwatertherapy.com</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="flex flex-col items-center md:items-start gap-4"
          >
            <a
              href="https://ashley-bass.clientsecure.me/request/service"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full md:w-auto text-center bg-primary text-primary-foreground px-10 py-4 rounded-md font-body font-medium tracking-wider text-sm uppercase hover:opacity-90 transition-opacity"
            >
              Get Started
            </a>
            <a
              href="mailto:ashley@stillwatertherapy.com"
              className="w-full md:w-auto text-center border border-border text-foreground px-10 py-4 rounded-md font-body font-medium tracking-wider text-sm uppercase hover:bg-background transition-colors"
            >
              Contact Us
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MidPageCTA;
